import React from 'react';
import { Building2 } from 'lucide-react';
import { company } from '../data/company';
import { BankPaymentCodes } from './BankPaymentCodes';

export const BankTransferDetails = ({ orderNumber, amount, bankTransfer }) => (
  <section className="bg-gray-50 border border-gray-300 rounded-lg p-4 sm:p-6" aria-labelledby="bank-transfer-title" data-testid="bank-transfer-details">
    <h3 id="bank-transfer-title" className="text-base sm:text-lg font-semibold mb-5 flex items-center gap-2">
      <Building2 className="w-5 h-5 shrink-0" aria-hidden="true" />
      Podaci za uplatu
    </h3>
    <dl className="space-y-4 text-sm">
      {[
        ['Primatelj', company.name, 'bank-account-holder'],
        ['Adresa primatelja', company.address, 'bank-account-address'],
        ['OIB', company.oib, 'bank-account-oib'],
        ['IBAN', company.iban, 'bank-iban'],
        ['Model', bankTransfer.model, 'bank-model'],
        ['Poziv na broj', bankTransfer.reference, 'bank-reference']
      ].map(([label, value, testId]) => (
        <div key={testId} className="grid grid-cols-1 sm:grid-cols-[140px_minmax(0,1fr)] gap-x-4 gap-y-1">
          <dt className="text-gray-600">{label}:</dt>
          <dd className="min-w-0 break-words font-semibold" data-testid={testId}>{value}</dd>
        </div>
      ))}
      <div className="grid grid-cols-1 sm:grid-cols-[140px_minmax(0,1fr)] gap-x-4 gap-y-1">
        <dt className="text-gray-600">E-mail:</dt>
        <dd className="min-w-0"><a className="font-semibold break-all underline-offset-4 hover:underline" href={`mailto:${company.email}`} data-testid="bank-contact-email">{company.email}</a></dd>
      </div>
      <div className="flex flex-wrap justify-between gap-3 border-t pt-4">
        <dt className="text-gray-600 font-semibold">Iznos:</dt>
        <dd className="font-bold text-lg" data-testid="bank-order-total">{amount.toFixed(2)} €</dd>
      </div>
    </dl>
    <p className="mt-4 text-sm text-gray-700" data-testid="bank-order-payment-status">
      Iznos uključuje 25 % PDV-a. Narudžba čeka vašu uplatu na navedeni račun.
    </p>
    <BankPaymentCodes data={bankTransfer} orderNumber={orderNumber} />
  </section>
);